
import React from 'react';
import "./styles.css";
import {
  TextField,
  Grid,
} from "@mui/material";

const Homeownerformimage = (props) => {
  const { data, name } = props
  return (

    <Grid className='home_container' sx={{ display: 'flex', flexDirection: 'row' }}>
      <Grid sx={{ display: 'flex', flexDirection: 'row', padding: '20px', marginTop: "19px", backgroundColor: '#FCFCFC', border: '1px solid #E3E3E3', borderRadius: "6px" }}>

        <Grid sx={{ display: 'flex', flexDirection: 'row' }}>
          <Grid sx={{ display: 'flex', flexDirection: 'row', padding: '20px', marginTop: "19px", backgroundColor: '#FCFCFC', border: '1px solid #E3E3E3', borderRadius: "6px" }}>

            <Grid >
              <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal', fontSize:'14px' }}>
                First name
              </label>
              <TextField
                style={{ fontFamily: 'Rubik', paddingBottom: '15px' }}
                size="small"
                InputProps={{ readOnly: true, style: {
                  backgroundColor: "white"                 
                } }}
                fullWidth
                disabled={false}
                focused={false}
                value={data.Username}

              />
              <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal', fontSize:'14px' }}>
                Email ID
              </label>
              <TextField
                style={{ fontFamily: 'Rubik' }}
                size="small"

                InputProps={{ readOnly: true, style: {
                  backgroundColor: "white"                 
                } }}
                // placeholder="Add Last Name"
                fullWidth
                disabled={false}
                focused={false}

                value={data.email}

              />

            </Grid>
            <Grid sx={{ marginLeft: '40px' }} >
              <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal', fontSize:'14px' }}>
                Last name
              </label>
              <TextField
                style={{ fontFamily: 'Rubik', paddingBottom: '15px', }}
                InputProps={{ readOnly: true, style: {
                  backgroundColor: "white"                 
                } }}
                size="small"
                disabled={false}
                focused={false}
                placeholder="Add Last Name"
                fullWidth

                value={data.Lastname}

              />
              <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal', fontSize:'14px' }}>
                Contact number
              </label>
              <TextField
                style={{ fontFamily: 'Rubik' }}
                InputProps={{ readOnly: true, style: {
                  backgroundColor: "white"                 
                } }}
                size="small"
                disabled={false}
                focused={false}
                placeholder="Add Last Name"
                fullWidth
                value={data.Mobilenumber}
              />
            </Grid>
          </Grid>
          


        </Grid>

        <Grid >
          <img className="icon"
            style={{ padding: '20Px', width: '79%', height: '90%' }}
            src={data.Insidepic}
            alt="link"
          />
        </Grid>
      </Grid>
      </Grid>






      )
}

      export default Homeownerformimage;